import React from "react";
import Navbar2 from "../Components/Navbar2";

function VolleyballCoaches() {
  return (
  <>
    <Navbar2 />
      <div className='container-fluid px-0 pb-4 pt-5'>
        <div className='h1 text-center'>
          VOLLEYBALL COACHES
        </div>
        <div className="container my-5">
          <div className="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border mb-4">
            <div className="col-lg-7 p-3 p-lg-5 pt-lg-3">
              <h1 className="display-4 fw-bold lh-1 text-body-emphasis">
                Sarah O'Neal
              </h1>
              <h2>
                15 Premier Head Coach
              </h2>
              <p className="lead">
                Sarah O&apos;Neal has been coaching volleyball for 8 years, working with athletes across 
                all age levels from 12U to 18U. She has coached for several clubs in the Austin area 
                and brings a deep love for the game rooted in her own playing experience.
              </p>
                <p className="lead">
                Sarah began her athletic journey as a dual-sport athlete in high school, where she 
                quickly fell in love with volleyball. In her senior year, she earned both first 
                and second team All-District honors in volleyball and basketball, 
                along with Academic All-State recognition. She played club volleyball in the 
                Austin area and continued her playing career at Temple College.
                </p>
                <p className="lead">
                  After two years at the collegiate level, an injury ended her competitive 
                  playing career, but Sarah transitioned immediately into coaching. Since then, 
                  her passion has only grown. She has worked alongside elite athletes such as Zoe 
                  Fleck and Khat Bell at various camps and has earned over 20 first-place medals 
                  with her teams. She has also led multiple teams to gold bracket finishes at national qualifiers.
                </p>
                <p className="lead">
                  Although early in her coaching career, Sarah has built a strong foundation by 
                  learning from veteran coaches across Texas. Her coaching philosophy emphasizes 
                  a balance of hard work and fun, with a focus on developing strong athletes and 
                  outstanding leaders both on and off the court.
              </p>
                <p className="lead">
                  <a href="mailto:soneal@adssportscomplex.com">
                    Email Sarah Here
                  </a>
                </p>
            </div>
            <div className="col-lg-4 offset-lg-1 p-0 shadow-lg">
              <img className="img w-100" src="/s3/coach_oneal.png" alt=""/>
            </div>
          </div>
          <div className="row p-4 pb-0 mb-4 pe-lg-0 pt-lg-5 align-items-center rounded-3 border">
            <div className="col-lg-7 p-3 p-lg-5 pt-lg-3">
              <h1 className="display-4 fw-bold lh-1 text-body-emphasis">
                Kelli Hardge
              </h1>
              <h2>Assistant Volleyball Director<br/>16 Elite Head Coach</h2>
              {/* <h2>
                15 Premier Head Coach
              </h2> */}
              <p className="lead">
                With over 33 years of coaching experience, Kelli Hardge brings passion,
                leadership, and a lifelong commitment to volleyball. Her journey began
                in 1986 as a player with Austin Juniors and continued at Texas A&M
                University with the TAMU Club team (1988–1992). She transitioned
                to coaching in 1992 and has since guided teams across all
                levels—from middle school to college.
              </p>
                <p className="lead">
                Kelli’s coaching highlights include leading St. Michaels to the
                TAPPS 1A regional playoffs, a TCA Championship with San Antonio
                College, and club success with Brazos Valley Juniors, San Marcos
                Area Volleyball Club, Outlaw Volleyball, and Cajunland Volleyball
                in New Orleans. She’s coached multiple age groups and competitive levels,
                including national teams and a top-5 finish at AAU Nationals with CTX Juniors.
                </p>
                <p className="lead">
                 Kelli is excited to bring her dedication to strong fundamentals, high volleyball
                 IQ, and team-first mindset to ADS, with a focus on leadership development
                 and college recruitment.
                </p>
                  <p className="lead">
                  <a href="mailto:khardge@adssportscomplex.com">
                    Email Kelli Here
                  </a>
                </p>
            </div>
            <div className="col-lg-4 offset-lg-1 p-0 shadow-lg">
              <img className="img w-100" src="/s3/coach_hardge.jpg" alt=""/>
            </div>
          </div>
        </div>
          {/* <div className="h4 ms-5 me-5 pb-3 fw-light">
            We offer year-round volleyball training for beginners and
            intermediate players ages 8–13. Programs focus on building fundamentals, 
            strategy, coordination, and teamwork—and we&apos;re always adding new sessions.
          </div> */}
      </div>
  </>
);
}

export default VolleyballCoaches;
